<template>
  <div>
    <vue-box class="bax-create-patient">
      <div class="bax-section-title">
        <h2 v-if="!isTPN()">Drug Details</h2>
        <h2 v-if="isTPN()">Product Details</h2>
      </div>
      <div>
        <div class="bax-form-with-indicator">
          <ul class="bax-diamond-list">
            <template v-if="isTPN()">
              <li
                class="bax-diamond-list-item"
                v-bind:class="{ 'bax-form-error': $v.drug1_name.$error }"
              >
                <label>Product</label>
                <v-autocomplete-select
                  :options="drugs"
                  v-model="drugOne"
                  label="title"
                  v-if="!isFavourite"
                >
                </v-autocomplete-select>
                <input
                  type="text"
                  disabled
                  v-else
                  :value="drug1_name"
                  class="bax-input-control"
                />
                <p
                  class="error"
                  v-if="$v.drug1_name.$dirty && !$v.drug1_name.required"
                >
                  Required field
                </p>
              </li>
            </template>
            <li
              class="bax-diamond-list-item delivery-dates"
              v-bind:class="{ 'full-width': !hasTreatmentDate }"
            >
              <div class="bax-nested-element">
                <div class="bax-inline-element d-md-flex">
                  <div class="bax-form-group bax-xs-input">
                    <label>Qty</label>
                  </div>
                  <div class="bax-form-group">
                    <label>Delivery dates</label>
                  </div>
                  <div class="bax-form-group" v-if="hasTreatmentDate">
                    <label>Treatment dates <span>(Optional)</span></label>
                  </div>
                </div>
                <div
                  v-for="(deliveryDateSet, index) in deliveryDateArray"
                  :value="deliveryDateSet"
                  :key="deliveryDateArray[index][3]"
                >
                  <div class="bax-inline-element d-md-flex">
                    <div
                      class="bax-form-group bax-xs-input"
                      v-bind:class="{
                        'bax-form-error':
                          $v.deliveryDateArray.$dirty &&
                          deliveryQtyError(deliveryDateArray[index][2], true),
                      }"
                    >
                      <input
                        class="bax-input-control"
                        type="text"
                        inputmode="numeric"
                        step="1"
                        v-model="deliveryDateArray[index][2]"
                        ref=""
                      />
                      <p
                        class="error"
                        v-if="
                          $v.deliveryDateArray.$dirty &&
                          deliveryQtyError(deliveryDateArray[index][2], true)
                        "
                      >
                        {{ deliveryQtyError(deliveryDateArray[index][2], true) }}
                      </p>
                    </div>
                    <div
                      class="bax-form-group"
                      v-bind:class="{
                        'bax-form-error':
                          $v.deliveryDateArray.$dirty &&
                          deliveryDateError(deliveryDateArray[index][0], true),
                      }"
                    >
                      <date-entry
                        v-model="deliveryDateArray[index][0]"
                        :showDateAlerts="true"
                        ref="dateEntryComp1"
                        @update-warning="updateWarning"
                      ></date-entry>
                      <p
                        class="error"
                        v-if="
                          $v.deliveryDateArray.$dirty &&
                          deliveryDateError(deliveryDateArray[index][0], true)
                        "
                      >
                        {{ deliveryDateError(deliveryDateArray[index][0], true) }}
                      </p>
                    </div>
                    <div
                      class="bax-form-group"
                      v-if="hasTreatmentDate"
                      v-bind:class="{
                        'bax-form-error':
                          $v.deliveryDateArray.$dirty &&
                          treatmentDateError(deliveryDateArray[index][0], deliveryDateArray[index][1]),
                      }"
                    >
                      <date-entry
                        v-model="deliveryDateArray[index][1]"
                        :showDateAlerts="true"
                        ref="dateEntryComp2"
                        :highlightWeekendHolidays="true"
                        @update-warning="updateWarning"
                      ></date-entry>
                      <p
                        class="error"
                        v-if="
                          $v.deliveryDateArray.$dirty &&
                          treatmentDateError(deliveryDateArray[index][0], deliveryDateArray[index][1])
                        "
                      >
                        {{ treatmentDateError(deliveryDateArray[index][0], deliveryDateArray[index][1]) }}
                      </p>
                    </div>
                  </div>
                  <div class="bax-add-element">
                    <a
                      href="#"
                      v-if="index == 0"
                      @click.prevent="deliveryDate_add"
                      title="Add another delivery date"
                    >
                      <i class="icon-add"></i>
                    </a>
                    <a
                      href="#"
                      v-if="index > 0"
                      @click.prevent="deliveryDate_remove(index)"
                      title="Remove delivery date"
                    >
                      <i class="icon-delete"></i>
                    </a>
                  </div>
                </div>
                <alert-box
                  :title="'Note'"
                  :date_warning="date_warning"
                  @update-warning="updateWarning"
                ></alert-box>
              </div>
            </li>
            <li class="bax-diamond-list-item" v-if="!isTPN()">
              <!-- FIrst/Primary drug -->
              <div class="bax-nested-element">
                <div
                  class="bax-form-group"
                  v-bind:class="{ 'bax-form-error': $v.drug1_name.$error }"
                >
                  <div class="bax-form-group" v-if="!isTPN()">
                    <label>Recent Orders</label>
                    <v-autocomplete-select
                      placeholder=""
                      :options="favourites"
                      label="title"
                      @change="onFavouriteChange"
                      v-model="favSelected"
                      v-if="!isFavourite"
                    ></v-autocomplete-select>
                    <input
                      type="text"
                      disabled
                      v-else
                      value=""
                      class="bax-input-control"
                    />

                  </div>

                  <template v-if="!isTPN()">
                    <label>Drug</label>
                    <label v-if="isTPN()">Product</label>

                    <v-autocomplete-select
                      placeholder=""
                      :options="drugs"
                      v-model="drugOne"
                      label="label"
                      v-if="!isFavourite"
                      @change="onDrugChange"
                    >

                    </v-autocomplete-select>
                    <input
                      type="text"
                      disabled
                      v-else
                      :value="drugOne.label ? drugOne.label : drugOne.title"
                      class="bax-input-control"
                    />
                    <p
                      class="error"
                      v-if="$v.drug1_name.$dirty && !$v.drug1_name.required"
                    >
                      Required field
                    </p>
                  </template>
                </div>
                <!-- FP Product code -->
                <div v-if="addingFpDrug && !isTPN()" class="bax-form-group">
                  <label>Product code</label>
                  <input
                    type="text"
                    disabled
                    :value="drug1_product_code"
                    class="bax-input-control"
                  />
                </div>

                <!-- Drug one dose and uom -->
                <div class="bax-inline-element d-md-flex " v-if="!isTPN()">
                  <div
                    class="bax-form-group bax-xs"
                    v-bind:class="{ 'bax-form-error': $v.drug1_dose.$error }"
                  >
                    <label>Dose</label>
                    <input
                      type="numeric"
                      step="0.01"
                      min="0"
                      class="bax-input-control"
                      v-model="drug1_dose"
                      :disabled="addingFpDrug"
                    />
                    <p
                      class="error"
                      v-if="$v.drug1_dose.$dirty && !$v.drug1_dose.required"
                    >
                      required
                    </p>
                    <p
                      class="error"
                      v-if="$v.drug1_dose.$dirty && !$v.drug1_dose.max"
                    >
                      Max dose {{ drug1_maxdose }}
                    </p>
                    <p
                      class="error"
                      v-if="$v.drug1_dose.$dirty && !$v.drug1_dose.maxDecimal"
                    >
                      Max decimal places is 2
                    </p>
                    <p
                      class="error"
                      v-if="$v.drug1_dose.$dirty && !$v.drug1_dose.gtzero"
                    >
                      Dose must be greater than zero
                    </p>
                  </div>
                  <div class="bax-form-group bax-xs">
                    <label>Unit</label>
                    <select
                      class="bax-input-control"
                      v-model="drug1_dose_uom"
                      v-if="!addingFpDrug"
                    >
                      <option
                        :value="i"
                        :key="i"
                        v-for="(uom, i) in drug1_uoms"
                      >
                        {{ uom }}
                      </option>
                    </select>
                    <input
                      type="text"
                      disabled
                      v-else
                      :value="drug1_dose_uom"
                      class="bax-input-control"
                    />
                  </div>
                  <div v-if="!drug2_id && drug1_stability_data" class="stability-section-container bax-form-group bax-xs d-flex align-items-end justify-content-start">
                    <button v-if="drug1_stability_data.containers" class="trigger-modal-stability bax-btn bax-btn-bordered-blue-brand" @click.prevent="onModalViewStabilityOpen()"><i class="icon-open"></i> View Stability</button>
                    <p v-if="drug1_stability_data.notes">{{ drug1_stability_data.notes }}</p>
                  </div>
                </div>

                <div role="alert" v-if="drug_warning">
                  <p style="color: #FA8300;">{{ drug_warning }}</p>
                </div>

                <div class="bax-del-element" v-if="!isTPN()">
                  <a href="#" @click.prevent="deleteDrugOne">
                    <i class="icon-delete"></i>
                  </a>
                </div>
              </div>

              <!-- Second drug -->
              <div
                class="bax-nested-element"
                v-if="displaySecondDrug && !isTPN()"
              >
                <div
                  class="bax-form-group"
                  v-bind:class="{ 'bax-form-error': $v.drug2_id.$error }"
                >
                  <select
                    class="bax-input-control"
                    v-model="drug2_id"
                    v-if="!isFavourite && !addingFpDrug"
                  >
                    <option
                      v-for="(opt, i) in drug2Options"
                      :key="i"
                      :value="i"
                    >
                      {{ drug2Labels[i]?drug2Labels[i]:drug2Options[i] }}
                    </option>
                  </select>
                  <input
                    type="text"
                    disabled
                    v-else
                    :value="drug2Labels[drug2_id] ? drug2Labels[drug2_id] : drug2_id"
                    class="bax-input-control"
                  />

                  <p v-if="$v.drug2_id.$dirty && !$v.drug2_id.required">
                    Required field
                  </p>
                </div>
                <div class="bax-inline-element d-md-flex">
                  <div
                    class="bax-form-group bax-xs"
                    v-bind:class="{ 'bax-form-error': $v.drug2_dose.$error }"
                  >
                    <label>Dose</label>
                    <input
                      type="numeric"
                      step="0.01"
                      class="bax-input-control"
                      v-model="drug2_dose"
                      :disabled="addingFpDrug"
                    />
                    <p v-if="$v.drug2_dose.$dirty && !$v.drug2_dose.required">
                      Required field
                    </p>
                    <p v-if="$v.drug2_dose.$dirty && !$v.drug2_dose.maxDecimal">
                      Max decimal places is 2
                    </p>
                    <p v-if="$v.drug2_dose.$dirty && !$v.drug2_dose.gtzero">
                      Dose must be greater than zero
                    </p>
                  </div>
                  <div class="bax-form-group bax-xs">
                    <label>Unit</label>
                    <select
                      class="bax-input-control"
                      v-model="drug2_dose_uom"
                      v-if="!addingFpDrug"
                    >
                      <option
                        :value="i"
                        v-for="(val, i) in drug2_uoms"
                        :key="i"
                      >
                        {{ val }}
                      </option>
                    </select>
                    <input
                      type="text"
                      disabled
                      v-else
                      :value="drug2_dose_uom"
                      class="bax-input-control"
                    />
                  </div>
                  <div v-if="drug2_id && drug2_stability_data" class="stability-section-container bax-form-group bax-xs d-flex align-items-end justify-content-start">
                    <button v-if="drug2_stability_data.containers" class="trigger-modal-stability bax-btn bax-btn-bordered-blue-brand" @click.prevent="onModalViewStabilityOpen()"><i class="icon-open"></i> View Stability</button>
                    <p v-if="drug2_stability_data.notes">{{ drug2_stability_data.notes }}</p>
                  </div>
                </div>
                <div class="bax-del-element">
                  <a href="#" @click.prevent="deleteSecondDrug"
                    ><i class="icon-delete"></i
                  ></a>
                </div>
              </div>

              <!-- Button to add more drug -->
              <div
                class="bax-add-element"
                v-if="hasDrugTwo && !displaySecondDrug"
              >
                <a
                  href="#"
                  class="d-flex align-items-center"
                  @click.prevent="showSecondDrug"
                >
                  <i class="icon-add"></i> Add another drug
                </a>
              </div>
            </li>
            <li class="bax-diamond-list-item" v-if="addingFpDrug || isTPN()">
              <!-- FP stability -->
              <div v-if="addingFpDrug || isTPN()" class="bax-form-group">
                <label>Stability</label>
                <input
                  type="text"
                  disabled
                  :value="drug1_stability"
                  class="bax-input-control"
                />
              </div>
            </li>

            <li class="bax-diamond-list-item" v-if="!isTPN()">
              <div class="bax-inline-element d-md-flex">
                <div
                  class="bax-form-group bax-md"
                  v-bind:class="{ 'bax-form-error': $v.adminRouteCode.$error }"
                >
                  <label for="route">Route of administration</label>
                  <select
                    id="route"
                    class="bax-input-control"
                    v-model="adminRouteCode"
                    v-if="!addingFpDrug && !isFavourite"
                  >
                    <option value="">- Select -</option>
                    <option
                      v-for="(adminRoute, i) in adminRoutes"
                      :key="i"
                      :value="i"
                    >
                      {{ adminRoute }}
                    </option>
                  </select>
                  <input
                    class="bax-input-control"
                    type="text"
                    disabled
                    :value="
                      adminRoutes[adminRouteCode] ? adminRoutes[adminRouteCode] : adminRouteCode
                    "
                    v-else
                  />
                  <p
                    v-if="$v.adminRouteCode.$dirty && !$v.adminRouteCode.required"
                  >
                    Required field
                  </p>
                </div>
                <div
                  class="bax-form-group bax-md"
                  v-bind:class="{ 'bax-form-error': $v.containerTypeId.$error }"
                >
                  <label for="container">Container types</label>
                  <select
                    id="container"
                    class="bax-input-control"
                    v-model="containerTypeId"
                    v-if="!addingFpDrug && !isFavourite"
                  >
                    <option value="">- Select -</option>
                    <option
                      v-for="(container, i) in containerTypes"
                      :key="i"
                      :value="i"
                    >
                      {{ container }}
                    </option>
                  </select>
                  <input
                    class="bax-input-control"
                    type="text"
                    disabled
                    :value="
                      containerTypes[containerTypeId]
                        ? containerTypes[containerTypeId]
                        : containerTypeId
                    "
                    v-else
                  />
                  <p
                    v-if="$v.containerTypeId.$dirty && !$v.containerTypeId.required"
                  >
                    Required field
                  </p>
                </div>
              </div>
            </li>
            <li class="bax-diamond-list-item" v-if="!isTPN()">
              <div
                class="bax-form-group"
                v-bind:class="{ 'bax-form-error': $v.diluent_id.$error }"
              >
                <label for="diluent"
                  >Diluent
                  <span v-if="isDiluentOptional">- Optional</span></label
                >
                <select
                  id="diluent"
                  class="bax-input-control"
                  v-model="diluent_id"
                  v-if="!addingFpDrug && !isFavourite"
                >
                  <option value="">- Select -</option>
                  <option v-for="(diluent, i) in diluents" :key="i" :value="i">
                    {{ diluent }}
                  </option>
                </select>
                <input
                  type="text"
                  disabled
                  :value="diluents[diluent_id] ? diluents[diluent_id] : diluent_id"
                  v-else
                  class="bax-input-control"
                />
                <p v-if="$v.diluent_id.$dirty && !$v.diluent_id.required">
                  Required field
                </p>
              </div>
              <div v-if="hasInfusionTime === true">
                <div class="bax-inline-element d-md-flex">
                  <br />
                  <div
                    class="bax-form-group bax-lg"
                    v-bind:class="{ 'bax-form-error': $v.infusionTime.$error }"
                  >
                    <label>Infusion Time</label>
                    <input
                      type="number"
                      step="0.01"
                      class="bax-input-control"
                      v-model="infusionTime"
                      :disabled="addingFpDrug || isFavourite"
                    />
                    <p
                      v-if="$v.infusionTime.$dirty && !$v.infusionTime.required"
                    >
                      Required field
                    </p>
                    <p
                      v-if="$v.infusionTime.$dirty && !$v.infusionTime.maxValue"
                    >
                      Max value 168 Hours
                    </p>
                    <p
                      v-if="$v.infusionTime.$dirty && !$v.infusionTime.minValue"
                    >
                      Min value 1
                    </p>
                    <p
                      v-if="$v.infusionTime.$dirty && !$v.infusionTime.maxDecimal"
                    >
                      Max decimal places is 2
                    </p>
                  </div>
                  <div
                    class="bax-form-group bax-sm"
                    v-bind:class="{ 'bax-form-error': $v.infusionTime.$error }"
                  >
                    <label>Infusion Time Unit</label>
                    <select
                      id="infusionTimeDuration"
                      class="bax-input-control"
                      v-model="infusionTimeDuration"
                      v-if="!addingFpDrug"
                      :disabled="addingFpDrug || isFavourite"
                    >
                      <option value="hours">Hours</option>
                      <option value="minutes">Minutes</option>
                      <option value="days">Days</option>
                    </select>
                    <input
                      type="text"
                      disabled
                      v-else
                      :value="infusionTimeDuration"
                      class="bax-input-control"
                    />
                  </div>
                </div>
                <p class="infusion-note">
                  Infusion time will display as hours on label
                </p>
              </div>
            </li>
            <li class="bax-diamond-list-item" v-if="!isTPN()">
              <div class="bax-inline-element d-md-flex flex-column">
                <div
                  class="bax-form-group"
                  v-bind:class="{ 'bax-form-error': $v.containerId.$error }"
                >
                  <label>Container description/Size</label>
                  <select
                    class="bax-input-control"
                    v-model="containerId"
                    v-if="!addingFpDrug && !isFavourite"
                  >
                    <option value="">- Select -</option>
                    <option
                      v-for="(desc, index) in containerDescriptions"
                      :key="index"
                      :value="index"
                    >
                      {{
                        selectedContainer[1] === "Syringe" ? desc.genericName : desc.containerName
                      }}
                    </option>
                  </select>
                  <input
                    v-else
                    disabled
                    type="text"
                    :value="
                      containerDescriptions[containerId]
                        ? containerDescriptions[containerId].genericName +
                          ' ' +
                          '(' +
                          containerDescriptions[this.containerId].size +
                          ')'
                        : containerId
                    "
                    class="bax-input-control"
                  />
                  <p v-if="$v.containerId.$dirty && !$v.containerId.required">
                    Required field
                  </p>
                </div>
                <div
                  class="bax-form-group">
                  <div class="bax-inline-element d-md-flex">
                    <div
                      v-if="hideExactFinalVolume !== true"
                      class="bax-form-group bax-sm"
                      v-bind:class="{ 'bax-form-error': $v.diluentVolume.$error }"
                    >
                      <label>Volume(mL)</label>
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        class="bax-input-control"
                        v-model="diluentVolume"
                        :disabled="!diluentExactFinalVolume"
                      />
                      <p
                        v-if="$v.diluentVolume.$dirty && !$v.diluentVolume.minValue"
                      >
                        Min value allowed {{ round_2(minDiluentVolume) }}mL
                      </p>
                      <p
                        v-if="$v.diluentVolume.$dirty && !$v.diluentVolume.maxValue"
                      >
                        Max value allowed {{ round_2(maxDiluentVolume) }}mL
                      </p>
                      <p
                        v-if="$v.diluentVolume.$dirty && !$v.diluentVolume.required"
                      >
                        Required field
                      </p>
                      <p
                        v-if="$v.diluentVolume.$dirty && !$v.diluentVolume.maxDecimal"
                      >
                        Max decimal places is 2
                      </p>
                      <p v-if="$v.diluentVolume.$dirty && !$v.diluentVolume.gtzero">
                        Volume must be greater than zero
                      </p>
                      <div class="bax-checkbox">
                        <input
                          type="checkbox"
                          @change="onExactVolumeChange"
                          name="diluentExactFinalVolume"
                          v-model="diluentExactFinalVolume"
                          :disabled="disableDiluentExactFinalVolume"
                          id="diluentExactFinalVolume"
                          class="css-checkbox"
                        />
                        <label class="css-label" for="diluentExactFinalVolume"
                          >Exact final volume</label
                        >
                      </div>
                    </div>
                    <div
                      v-if="hideExactFinalVolume !== true"
                      class="bax-form-group bax-md"
                    >
                      <label>Max total volume(mL)</label>
                      <input
                        v-if="maxDiluentVolume < 5000"
                        type="number"
                        step="0.01"
                        min="0"
                        class="bax-input-control"
                        v-model="maxDiluentVolume"
                        :disabled="true"
                      />
                      <input
                        v-else
                        type="number"
                        step="0.01"
                        min="0"
                        class="bax-input-control"
                        :disabled="true"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="bax-diamond-list-item" v-if="!isTPN()">
              <div
                class="bax-form-group"
                v-bind:class="{
                  'bax-form-error': $v.ancillary1Id.$dirty && !$v.ancillary1Id.required,
                }"
              >
                <label
                  >Ancillary
                  <span v-if="!hasDefaultAncillary">- Optional</span></label
                >
                <select
                  class="bax-input-control"
                  v-model="ancillary1Id"
                  v-if="!addingFpDrug && !isFavourite"
                >
                  <option value="">- Select -</option>
                  <option
                    v-for="(ancillary, i) in ancillaries"
                    :key="i"
                    :value="ancillary.componentID"
                  >
                    {{ ancillary.genericName }}
                  </option>
                </select>
                <input
                  v-else-if="!addingFpDrug"
                  type="text"
                  disabled
                  :value="
                    findAncilliary(ancillaries, ancillary1Id)
                      ? findAncilliary(ancillaries, ancillary1Id).genericName
                      : ''
                  "
                  class="bax-input-control"
                />
                <input
                  v-else
                  type="text"
                  disabled
                  :value="ancillary1Id"
                  class="bax-input-control"
                />

                <p v-if="$v.ancillary1Id.$dirty && !$v.ancillary1Id.required">
                  Required field
                </p>
              </div>
              <div
                class="bax-add-element"
                v-if="showSecondAncillary === false && !addingFpDrug && !isFavourite"
              >
                <a
                  href="#"
                  v-if="showSecondAncillary === false"
                  @click.prevent="displaySecondAncillary"
                  class="d-flex align-items-center"
                >
                  <i class="icon-add"></i> Add another ancillary
                </a>
              </div>

              <div
                class="bax-nested-element"
                v-if="showSecondAncillary === true"
              >
                <select
                  class="bax-input-control"
                  v-model="ancillary2Id"
                  v-if="!addingFpDrug && !isFavourite"
                >
                  <option value="">- Select -</option>
                  <option
                    v-for="(ancillary, i) in ancillaries"
                    :key="i"
                    :value="ancillary.componentID"
                  >
                    {{ ancillary.genericName }}
                  </option>
                </select>
                <input
                  v-else-if="!addingFpDrug"
                  type="text"
                  disabled
                  :value="
                    findAncilliary(ancillaries, ancillary2Id)
                      ? findAncilliary(ancillaries, ancillary2Id).genericName
                      : ''
                  "
                  class="bax-input-control"
                />
                <input
                  v-else
                  type="text"
                  disabled
                  :value="ancillary2Id"
                  class="bax-input-control"
                />
                <div class="bax-del-element">
                  <a
                    @click.prevent="showSecondAncillary = false"
                    href="#"
                    title="Remove delivery date"
                    ><i class="icon-delete"></i
                  ></a>
                </div>
              </div>
            </li>
          </ul>

          <div class="bax-cta-block d-md-flex">
            <div class="bax-checkbox" v-if="!addingFpDrug">
              <input
                type="checkbox"
                name="onHold"
                v-model="onHold"
                id="onHold"
                class="css-checkbox"
                checked=""
                :disabled="addingFpDrug"
              />
              <label for="onHold" class="css-label">Place item on hold</label>
            </div>
            <button
              v-if="edit === false && !isTPN()"
              type="button"
              class="mt-3 mt-md-0 bax-btn bax-btn bax-btn-blue ml-auto"
              @click="addOrderDrug"
            >
              Add this drug to the order
            </button>
            <button
              v-if="edit === false && isTPN()"
              type="button"
              class="mt-3 mt-md-0 bax-btn bax-btn bax-btn-blue ml-auto"
              @click="addOrderTPNProduct"
            >
              Add product to the order
            </button>

            <button
              v-if="edit === true && !isTPN()"
              type="button"
              class="mt-3 mt-md-0 bax-btn bax-btn bax-btn-blue ml-auto"
              @click="updateDrug"
            >
              Finish editing
            </button>
            <button
              v-if="edit === true && isTPN()"
              type="button"
              class="mt-3 mt-md-0 bax-btn bax-btn bax-btn-blue ml-auto"
              @click="updateOrderTPNProduct"
            >
              Finish editing
            </button>
          </div>
        </div>
      </div>
    </vue-box>

    <div
      class="bax-drug-detail-action-item cancel-buttons"
      v-if="inEditMode === false"
    >
      <cancel-order-modal
        :add_more="this.orderInfo.add_more"
        :cancelItem="isTPN() ? 'product' : 'Drug'"
      ></cancel-order-modal>
    </div>

    <exceed-dosage-modal
      :open="this.maxDosageModalOpen"
      :drugs="this.drugsExceedingMaxDosage"
      @maxDosageDenied="maxDosageModalOpen = false"
      @maxDosageApproved="maxDosageApproved()"
    ></exceed-dosage-modal>

    <stability-error-modal
      :open="this.showStabilityError"
      @stabilityReview="showStabilityError = false"
      @stabilitySubmit="stabilitySubmit()"
    ></stability-error-modal>

    <generic-error-modal
      :message="this.genericErrorText"
      @ErrorAccepted="genericErrorText = ''"
    ></generic-error-modal>

    <exceed-container-size-modal
      :open="this.exceedContainerModalOpen"
      :drug="this.drugExceedingContainerSize"
      @doNotSplitDosageIntoContainers="exceedContainerModalOpen = false"
      @updateDosesVolumes="handleVolumesUpdate"
    ></exceed-container-size-modal>

    <add-drug-complete-modal
      :open="addDrugComplete"
      :patient="patient"
      :draftSaved="draftSaved"
      @close="closeAddDrugModal"
    ></add-drug-complete-modal>

    <draft-order-modal
      v-if="inEditMode === false"
      :open="draftModal"
      @cancel="draftModal = false"
    ></draft-order-modal>

    <vue-modal :open="editDrugModal" class="submit-order">
      <div>
        <div
          class="bax-icon bax-success d-flex align-items-center justify-content-center"
        >
          <i class="icon-tick"></i>
        </div>
        <h2 v-if="!isTPN()">Drug updated successfully.</h2>
        <h2 v-if="isTPN()">Product updated successfully.</h2>
        <div class="bax-modal-action-items">
          <ul class="d-md-flex justify-content-center">
            <li>
              <a
                href="#"
                @click.prevent="goBackAfterEdit"
                class="bax-btn bax-btn-blue"
                >Back</a
              >
            </li>
          </ul>
        </div>
      </div>
    </vue-modal>

    <vue-modal :open="formInProgress">
      <div class="bax-modal-content bax-modal-icon-content text-center">
        <div
          class="bax-icon bax-remove d-flex align-items-center justify-content-center"
        >
          <i class="icon-delete"></i>
        </div>
        <h2>Discard drug?</h2>
        <p>
          You have not yet added this drug to your order. Go back and add it.
        </p>
        <div class="bax-modal-action-items">
          <ul class="d-md-flex justify-content-center">
            <li>
              <a
                href="#"
                @click.prevent="goToReview"
                class="bax-btn bax-btn-bordered bax-btn-bordered-dark-gray-1"
                >Discard & proceed</a
              >
            </li>
            <li>
              <a
                href="#"
                class="bax-btn bax-btn-orange mt-3 mt-md-0"
                @click.prevent="formInProgress = false"
                >Go back</a
              >
            </li>
          </ul>
        </div>
      </div>
    </vue-modal>

    <ViewStabilityModal class="view-stability-modal" :open="modalViewStability" :data="drug2_id ? drug2_stability_data : drug1_stability_data" @modal_view_stability_close="onModalViewStabilityClose()" />
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import DrugService from "@/core/api/drug/drug.service";
import OrderDrugService from "@/core/api/order/orderDrug.service";
import DateEntry from "@/components/ui/DateEntry.vue";
import { scrollPageToTop } from "@/core/helpers";

import AddDrugCompleteModal from "@/views/Order/DrugDetail/AddDrugCompleteModal.vue";
import DraftOrderModal from "@/components/order/DraftOrder/DraftOrderModal.vue";
import CancelOrderModal from "@/components/order/CancelOrderModal.vue";
import ExceedDosageModal from "@/components/order/ExceedDosageModal.vue";
import GenericErrorModal from "@/components/order/GenericErrorModal.vue";
import StabilityErrorModal from "@/components/order/StabilityErrorModal.vue";
import ExceedContainerSizeModal from "@/components/order/ExceedContainerSizeModal.vue"
import ViewStabilityModal from "@/components/order/ViewStabilityModal.vue";

import OrderService from "@/core/api/order/order.service";
import utilsMixin from "@/mixins/utilsMixin";
import orderMixin from "@/mixins/orderMixin";
import tpnMixin from "@/mixins/tpnMixin";
import AlertBox from "@/components/ui/Alert/AlertBox.vue";

import formValidations from "./drugValidations";

export default {
  name: "OrderDrugForm",
  mixins: [utilsMixin, orderMixin, tpnMixin],
  components: {
    GenericErrorModal,
    DateEntry,
    AlertBox,
    ViewStabilityModal,
    AddDrugCompleteModal,
    DraftOrderModal,
    CancelOrderModal,
    ExceedDosageModal,
    ExceedContainerSizeModal,
    StabilityErrorModal,
  },
  props: {
    patient: {
      type: Object,
      default() {
        return {};
      },
    },
    edit: {
      type: Boolean,
      default: false,
    },
    drug: {
      default() {
        return {};
      },
    },
    add_more: {
      type: Boolean,
      default: false,
    },
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      modalViewStability: false,
      // Order
      draftSaved: null,
      // Misc
      draftModal: false,
      addDrugComplete: false,
      inEditMode: false,
      editDrug: {},
      editDrugModal: false,
      drugCount: 0,
      formInProgress: false,
      isFavourite: false,
      drugs: [],
      favourites: [],
      populatingFavourite_drugOne: false,
      addingFpDrug: false,
      favSelected: null,

      adminRoutes: [],
      containerTypes: [],
      diluents: [],
      containerDescriptions: [],
      ancillaries: [],

      // Date warning alert
      date_warning: "",
      // conditional state for diluent, infusion and diluent volume
      isDiluentOptional: false,
      hasInfusionTime: false,
      hideExactFinalVolume: false,
      diluentExactFinalVolume: false,
      disableDiluentExactFinalVolume: false,

      // quantity related info
      minQuantity: "",
      max_batch_size: "",
      // maxQuantity: '',
      qtyMultiple: "",

      // Diluent volume related info
      hasDefaultDiluentVolume: true,
      isExactVolumeOptional: false,
      minDiluentVolume: "",
      maxDiluentVolume: "",

      // drug one related info
      drugOne: {},
      drug_warning: "",
      drug1_uoms: [],
      drug1_maxdose: "",
      drug1_product_code: "",
      drug1_stability: "",
      drug1_stability_data: false,

      // drug two related info
      displaySecondDrug: false,
      hasDrugTwo: false,
      drug2Options: [],
      drug2Labels: [],
      drug2_uoms: [],
      drug2_dose_uom: "",
      drug2_stability_data: false,

      // ancillary related info
      hasDefaultAncillary: false,
      showSecondAncillary: false,
      defaultAncillaryValue: "",

      // treatment date related info
      hasTreatmentDate: true,

      // Extra Data to be passed to add/edit api
      selectedContainer: {},
      selectedConatierDescId: "",
      oldDrugPresentationId: "",
      drugPresentationId: "",

      /**
       * Data for form submission or api required fields
       */
      quantity: "", // unused now
      drug1_name: "",
      drug1_dose: "",
      drug1_doses_split: {},
      drug1_dose_uom: "",
      drug2_dose: "",
      drug2_id: "",
      drug2_maxdose: "",
      adminRouteCode: "",
      containerTypeId: "",
      diluent_id: "",
      infusionTime: "",
      infusionTimeDuration: "hours",
      containerId: "",
      diluentVolume: "",
      ancillary1Id: "",
      ancillary2Id: "",
      treatmentDate: "",
      deliveryDateArray: [],
      onHold: false,
      maxDosageExceededAccepted: false,
      maxDosageModalOpen: false,
      drugsExceedingMaxDosage: [],
      exceedContainerModalOpen: false,
      drugExceedingContainerSize: {
        dosage: null,
        name: null,
        unit: null
      },
      genericErrorText: "",
      showStabilityError: false,
      overrideStability: false,
      type: "",
      containerPartCode: false,
    };
  },
  /**
   * Form validations rules
   * @type Object
   */
  validations: formValidations,
  watch: {
    patient(val) {
      if (typeof val.patientId !== "undefined") {
        this.hasTreatmentDate = true;
      } else {
        this.hasTreatmentDate = false;
      }
    },
    drugOne(val) {
      if (this.populatingFavourite_drugOne) {
        this.populatingFavourite_drugOne = false;
        return;
      }
      this.drugOne_mx(val);
      this.favSelected = null;
      // this.drug1_name = '';
      // this.drug1_dose = '';
      // this.drug1_dose_uom = '';
      // this.drug1_uoms = [];
      //
      // // fp drug
      // this.drug1_stability = '';
      // this.drug1_product_code = '';
      //
      // // second drug
      // this.displaySecondDrug = false;
      // this.hasDrugTwo = false;
      // this.drug2Options = [];
      // this.drug2_maxdose = '';
      // this.drug2_dose_uom = '';
      // this.drug2_uoms = [];
      // this.drug2_id = '';
      //
      // if (typeof val.title !== 'undefined') {
      //     this.onDrugOneSelect();
      // }
    },
    drug1_dose() {
      this.maxDosageExceededAccepted = false;
    },
    drug1_name(val) {
      if (val === "") {
        return;
      }
      if (this.populatingFavourite_drug1_name) {
        this.populatingFavourite_drug1_name = false;
        return;
      }

      if (this.isTPN()) {
        this.getTpnDrugInfo();
      } else if (this.addingFpDrug) {
        this.getFpDrugInfo();
      } else {
        this.drug1_stability_data = false;
        this.getDrugOnePresentation();
      }

      if (val !== "" && this.drug1_name !== "") {
        this.getAdminRoutes();
      }
    },
    drug1_dose_uom(val) {
      if (val === "") {
        return;
      }
      if (this.populatingFavourite_drug1_dose_uom) {
        this.populatingFavourite_drug1_dose_uom = false;
        return;
      }
      if (val !== "" && this.drug1_dose_uom !== "") {
        this.getAdminRoutes();
      }
    },
    adminRouteCode(val) {
      if (this.addingFpDrug) {
        if (val === "") {
          this.containerTypeId = "";
        }

        return;
      }

      if (this.populatingFavourite_adminRouteCode) {
        this.populatingFavourite_adminRouteCode = false;
        return;
      }

      this.containerTypeId = "";
      this.containerTypes = [];

      if (val !== "") {
        this.getContainerTypes();
      }
    },
    containerTypeId(val) {
      if (this.addingFpDrug) {
        if (val === "") {
          this.diluent_id = "";
          this.infusionTime = "";
          this.infusionTimeDuration = "hours";
          this.containerId = "";
        }
        return;
      }
      if (this.populatingFavourite_containerTypeId) {
        this.populatingFavourite_containerTypeId = false;
        return;
      }

      this.isDiluentOptional = false;
      this.diluent_id = "";
      this.diluents = [];
      this.infusionTime = "";
      this.infusionTimeDuration = "hours";
      this.containerId = "";
      this.containerDescriptions = [];
      if (val !== "") {
        this.getDiluents();
      }
    },
    diluent_id(val) {
      if (this.addingFpDrug) {
        return;
      }
      if (this.populatingFavourite_diluent_id) {
        this.populatingFavourite_diluent_id = false;
        return;
      }

      this.containerId = "";
      this.containerDescriptions = [];

      if (val !== "" || this.isDiluentOptional) {
        this.getContainerDescriptions();
      }
    },
    infusionTime(val) {
      if (this.addingFpDrug) {
        return;
      }

      if (this.populatingFavourite_infusionTime) {
        this.populatingFavourite_infusionTime = false;
        return;
      }

      this.containerId = "";
      this.containerDescriptions = [];

      if (val !== "") {
        this.getContainerDescriptions();
      }
    },
    infusionTimeDuration(val) {
      if (this.addingFpDrug) {
        return;
      }

      this.containerId = "";
      this.containerDescriptions = [];

      if (val !== "") {
        this.getContainerDescriptions();
      }
    },
    containerId(val) {
      if (this.addingFpDrug) {
        if (val === "") {
          this.diluentVolume = "";
          this.ancillary1Id = "";
          this.ancillary2Id = "";
        }

        return;
      }

      if (this.populatingFavourite_containerId) {
        this.populatingFavourite_containerId = false;
        return;
      }

      this.ancillaries = [];
      this.ancillary1Id = "";
      this.ancillary2Id = "";
      this.hasDefaultAncillary = false;
      this.defaultAncillaryValue = "";
      this.showSecondAncillary = false;

      this.minDiluentVolume = "";
      this.maxDiluentVolume = "";

      this.setDefaultDiluentVolume();

      if (val !== "") {
        this.getAncillaries();
      }
    },
    defaultAncillaryValue(val) {
      if (val !== "") {
        this.setDefaultAncillary();
      }
    },
    ancillary1Id(val) {
      if (this.addingFpDrug) {
        return;
      }

      if (val !== "") {
        this.onAncillaryChange();
      }
    },
    ancillary2Id(val) {
      if (this.addingFpDrug) {
        return;
      }

      if (val !== "") {
        // this.onAncillaryChange();
      }
    },
  },
  async created() {
    // Create draft

    if (this.isTPN()) {
      this.type = "TPN";
    } else {
      this.type = "CMP";
    }

    this.checkUpdateDraft();

    this.inEditMode = this.edit;

    await this.mounted_mx();

    this.getOrderInfo();

    let response = false;
    if (!this.isTPN()) {
      response = await DrugService.getAllDrugs();
    } else {
      response = await DrugService.getAllTPNProducts();
    }
    this.drugs = response.data;

    /**
     * Debounced the call to 1000ms
     */
    this.getAdminRoutes = _.debounce(this.getAdminRoutes, 1000);
    this.getContainerDescriptions = _.debounce(this.getContainerDescriptions, 1000);

    if (typeof this.patient.patientId !== "undefined") {
      this.hasTreatmentDate = true;
    } else {
      this.hasTreatmentDate = false;
    }

    if (this.inEditMode) {
      this.editDrug = _.cloneDeep(this.drug);
      if (this?.editDrug?.drugOne.type === "TPN") {
        this.drugOne = this.editDrug.drugOne;
        this.addingFpDrug = false;
        // this.quantity = this.editDrug.quantity;
        this.drug1_product_code = this.drugOne.tpn_code;
        this.oldDrugPresentationId = this.editDrug.oldDrugPresentationId;
        this.treatmentDate = this.editDrug.treatmentDate;
        if (this.editDrug.deliveryDateArray) {
          this.deliveryDateArray = this.editDrug.deliveryDateArray;
          this.deliveryDate_recalc();
        }
      } else if (this?.editDrug?.drugOne?.type === 'FP') {
        this.drugOne = this.editDrug.drugOne;
        this.addingFpDrug = true;
        // this.quantity = this.editDrug.quantity;
        this.drug1_product_code = this.drugOne.finishedProductCode;
        this.oldDrugPresentationId = this.editDrug.oldDrugPresentationId;
        this.treatmentDate = this.editDrug.treatmentDate;
        if (this.editDrug.deliveryDateArray) {
          this.deliveryDateArray = this.editDrug.deliveryDateArray;
          this.deliveryDate_recalc();
        }
      } else {
        this.addingFpDrug = false;
        const selectedEditDrug = this.drugs.find((drug) => drug.title === this.editDrug.drug1_name);
        this.drugOne = selectedEditDrug;

        // this.quantity = this.editDrug.quantity;
        this.drug1_name = this.editDrug.drug1_name;
        this.treatmentDate = this.editDrug.treatmentDate + "";
        if (this.editDrug.deliveryDateArray) {
          this.deliveryDateArray = this.editDrug.deliveryDateArray;
          this.deliveryDate_recalc();
        }
        this.oldDrugPresentationId = this.editDrug.drugPresentationId;
        this.onHold = this.editDrug.onHold;
        this.isFavourite = this.editDrug.isFavourite;

        // Setting empty value after value is assigned, this pattern is followed for all drugEdit data
        // this way, the form can only recieve new sets of data at initial loading phase
        // this.editDrug.quantity = '';
        this.editDrug.drug1_name = "";
        this.editDrug.treatmentDate = "";
        this.editDrug.drugPresentationId = "";
        this.editDrug.onHold = "";
      }
    }
  },
  methods: {
    handleVolumesUpdate(dosesSplit) {
      this.drug1_doses_split = dosesSplit;
      this.exceedContainerModalOpen = false;

      // Was this an edit that resulted in a split? If so remove the original drug from the order.
      if (this.edit) {
        DrugService.deleteDrugFromOrder({
          orderRef: this.$route.params.orderId,
          drugPresentationId: this.drugPresentationId,
          patientId: this.patient.patientId ? this.patient.patientId : false,
          orderLineItemId: this.editDrug.orderLineItemId,
        });
      }

      this.submitDrug()
    },
    onDrugChange(f) {
      this.drug1_doses_split = {}
      if (!f) this.drugOne = {}
      this.drug1_stability_data = false;
    },
    updateWarning(newWarning) {
      this.date_warning = newWarning;
    },
    /**
     * Gets called when drug one is selected from auto-complete
     * onChange event for data[drug1_name]
     *
     */
    onDrugOneSelect() {
      this.drug1_name = this.drugOne.title;
      this.drug_warning = '';
      if (this.drugOne.type === "TPN") {
        this.addingFpDrug = false;
        this.minQuantity = this.drugOne.min_order_quantity;
        this.max_batch_size = this.drugOne.max_batch_size;
        this.drug1_product_code = this.drugOne.tpn_code
          ? this.drugOne.tpn_code
          : this.drugOne.finish_product_code;
        this.drug1_stability = this.drugOne.drug1_stability;
        this.qtyMultiple = parseInt(this.drugOne.accept_multiple, 0);
      } else if (this.drugOne.type === "FP") {
        this.addingFpDrug = true;
        this.minQuantity = this.drugOne.min_order_quantity;
        this.drug1_product_code = this.drugOne.finish_product_code;
        this.drug1_stability = this.drugOne.drug1_stability;
        this.qtyMultiple = parseInt(this.drugOne.accept_multiple, 0);
      } else {
        this.addingFpDrug = false;
      }
    },
    /**
     * Gets called once drug1_name is set
     * this api call for now is only called for non-fp drug
     *
     */
    async getDrugOnePresentation() {
      try {
        const response = await DrugService.getDrugInfo(this.drug1_name);
        this.drug1_uoms = response.maxdoseUoms;
        this.drug1_dose_uom = response.maxdoseUom;
        this.drug1_maxdose = response.maxdose;
        if (!this.isFavourite) {
          this.drug1_stability_data = response.stability_data;
        } else {
          this.drug1_stability_data = false;
        }

        this.checkForDrugTwo(response);

        if (this.inEditMode) {
          this.drug1_dose = this.editDrug.drug1_dose;
          this.editDrug.drug1_dose = "";

          if (this.editDrug.drug2_id !== null) {
            this.displaySecondDrug = true;
            this.drug2_id = this.editDrug.drug2_id;
            this.drug2_dose = this.editDrug.drug2_dose;
            this.drug2_maxdose = this.editDrug.drug2_maxdose;
            this.drug2_dose_uom = this.editDrug.drug2_maxdose_uom;
          } else {
            this.displaySecondDrug = false;
          }
        }

        this.getAdminRoutes();
      } catch (err) {
        // console.log(err);
      }
    },
    /**
     * Based on the drug one selected, if the drugPresentation contain drug2 related info
     * we show drug two related input element and info
     *
     * @param  object drug   DrugOne selected
     */
    checkForDrugTwo(drug) {
      if (typeof drug.drug2 === "undefined") {
        this.hasDrugTwo = false;
        return;
      }

      this.hasDrugTwo = true;

      this.drug2Options = drug.drug2.drug2_options;
      this.drug2Labels = drug.drug2.drug2_labels;
      this.drug2_maxdose = drug.drug2.drug2_maxdose;
      this.drug2_uoms = drug.drug2.drug2_uoms_options;

      const drug2MaxDoseUom = Object.values(drug.drug2.drug2_uoms_options)[0];
      this.drug2_dose_uom = drug2MaxDoseUom;

      if (!this.isFavourite) {
          this.drug2_stability_data = drug.drug2.drug2_stability_data;
        } else {
          this.drug2_stability_data = false;
        }
    },
    async getTpnDrugInfo() {
      const data = {
        reference: "getTpnDrugInfo",
        drug1_name: this.drug1_name,
        type: "TPN",
        code: this.drug1_product_code,
      };
      const response = await DrugService.getTPNProductInfo(data);

      this.drug1_stability =
        response.data.stabilityStorage +
        " " +
        response.data.stabilityUOM +
        " " +
        response.data.stabilityStorageType;

      this.minQuantity = response.data.min_order_quantity;
      this.max_batch_size = response.data.max_batch_size;
      this.qtyMultiple = parseInt(response.data.accept_multiple, 0);
    },
    /**
     * Gets finished product info
     * Mock info
     *
     */
    async getFpDrugInfo() {
      const data = {
        reference: "getFpDrugInfo",
        drug1_name: this.drug1_name,
        drug1Dose: this.drug1_dose,
        drug1_maxdose_uom: this.drug1_dose_uom,
        type: "FP",
        fp_code: this.drug1_product_code,
      };

      const response = await DrugService.basicDrugInfo(data);
      const drugInfo = response.data;
      this.refreshPresentations_mx(response.data);

      this.oldDrugPresentationId = drugInfo.finishedProductCode;
      this.drug1_dose = this.round_2(drugInfo.drug1Dose);
      this.drug1_maxdose = drugInfo.drug1_maxdose;
      this.drug1_dose_uom = drugInfo.drug1UOM;
      this.drug1_stability = drugInfo.stability;
      this.adminRouteCode = drugInfo.administrationRouteDescription;
      this.containerTypeId = String(drugInfo.containerType);
      this.diluent_id = drugInfo.diluentGenericName;
      this.containerId = drugInfo.deviceGenericName;
      this.diluentVolume = this.round_2(drugInfo.totalVolume); // round to 2 dp
      this.diluentExactFinalVolume = false;
      this.disableDiluentExactFinalVolume = true;
      this.ancillary1Id = drugInfo.ancillary1GenericName;
      this.ancillary2Id = drugInfo.ancillary2GenericName;

      if (drugInfo.infusionTime) {
        this.hasInfusionTime = true;
        this.infusionTime = this.round_2(drugInfo.infusionTime);
        if (drugInfo.infusionTimeDuration) {
          this.infusionTimeDuration = drugInfo.infusionTimeDuration.toLowerCase();
        }
      }

      if (drugInfo.drug2GenericName !== "") {
        this.displaySecondDrug = true;
        this.hasDrugTwo = true;
        this.drug2_id = drugInfo.drug2GenericName;
        this.drug2_dose = this.round_2(drugInfo.drug2_dose);
        this.drug2_maxdose = drugInfo.drug2_maxdose;
        this.drug2_dose_uom = drugInfo.drug2UOM;
      }
    },
    /**
     * Fetch admin routes based on drug presentation
     *
     */
    async getAdminRoutes() {
      if (!this.drug1_dose_uom) {
        return;
      }
      const data = {
        reference: "getAdminRoutes",
        drug1_name: this.drug1_name,
        drug1Dose: this.drug1_dose,
        drug1_maxdose_uom: this.drug1_dose_uom,
        type: this.drugOne.type,
        fp_code: this.drug1_product_code,
      };
      if (this.displaySecondDrug && this.drug2_id !== "") {
        data.drug2_id = this.drug2_id;
        data.drug2_dose_uom = this.drug2_dose_uom;
      }

      const response = await DrugService.basicDrugInfo(data);

      if (response.data.warning) {
        this.drug_warning = response.data.warning;
      }
      this.adminRoutes = response.data.admin_route_options ? response.data.admin_route_options : [];
      this.refreshPresentations_mx(response.data);

      if (this.inEditMode && !this.addingFpDrug) {
        this.adminRouteCode = this.editDrug.adminRouteCode;
        this.editDrug.adminRouteCode = "";
      }
    },
    /**
     * Get container types once route of admin is selected
     * Event called on adminRouteCode value is changed
     * Fetch container types for drugPresentation
     *
     */
    async getContainerTypes() {
      if (!this.drug1_dose_uom) {
        return;
      }
      const data = {
        reference: "getContainerTypes",
        drug1Dose: this.drug1_dose,
        drug1_name: this.drug1_name,
        drug1_maxdose_uom: this.drug1_dose_uom,
        admin_route_code: this.adminRouteCode,
        type: this.drugOne.type,
      };

      if (this.containerPartCode) {
        data.containerPartCode = this.containerPartCode;
      }

      if (this.displaySecondDrug && this.drug2_id !== "") {
        data.drug2_id = this.drug2_id;
        data.drug2_dose_uom = this.drug2_dose_uom;
      }

      const response = await DrugService.basicDrugInfo(data);
      this.containerTypes = response.data.container_options;
      this.refreshPresentations_mx(response.data);

      if (this.inEditMode) {
        this.containerTypeId = String(this.editDrug.containerTypeId);
        this.editDrug.containerTypeId = "";
      }
    },
    /**
     * Get diluents types once container type is selected
     * Event called on containerTypeId value is changed
     * Fetch diluents types for drugPresentation
     *
     */
    async getDiluents() {
      if (!this.drug1_dose_uom) {
        return;
      }
      const data = {
        reference: "getDiluents",
        drug1_name: this.drug1_name,
        drug1Dose: this.drug1_dose,
        drug1_maxdose_uom: this.drug1_dose_uom,
        admin_route_code: this.adminRouteCode,
        containerTypeId: this.containerTypeId,
        type: "PS",
      };

      if (this.displaySecondDrug && this.drug2_id !== "") {
        data.drug2_id = this.drug2_id;
        data.drug2_dose_uom = this.drug2_dose_uom;
      }

      const response = await DrugService.basicDrugInfo(data);
      this.diluents = response.data.diluent_options;
      this.isDiluentOptional = response.data.diluent_is_optional;
      this.refreshPresentations_mx(response.data);

      if (this.inEditMode) {
        this.diluent_id = this.editDrug.diluent_id;
        this.infusionTime = this.round_2(this.editDrug.infusionTime);
        this.infusionTimeDuration = this.editDrug.infusionTimeDuration;
        this.editDrug.infusionTime = "";
        this.editDrug.infusionTimeDuration = "hours";
        this.editDrug.diluent_id = "";
      }
      this.checkDrugConditions();

      if (this.isDiluentOptional === true && this.hasInfusionTime === false) {
        await this.getContainerDescriptions();
      }
    },
    /**
     * Get container descriptions once diluent is selected
     * Event called on diluentId value is changed
     * Fetch descriptions for drugPresentation
     *
     */
    async getContainerDescriptions() {
      if (!this.drug1_dose_uom) {
        return;
      }
      const data = {
        reference: "getContainerDescriptions",
        drug1Dose: this.drug1_dose,
        drug1_name: this.drug1_name,
        drug1_maxdose_uom: this.drug1_dose_uom,
        admin_route_code: this.adminRouteCode,
        containerTypeId: this.containerTypeId,
        diluent_id: this.diluent_id,
        infusionTime: this.round_2(this.infusionTime),
        infusionTimeDuration: this.infusionTimeDuration,
        type: this.drugOne.type,
      };

      if (this.containerPartCode) {
        data.containerPartCode = this.containerPartCode;
      }

      if (this.displaySecondDrug && this.drug2_id !== "") {
        data.drug2_id = this.drug2_id;
        data.drug2_dose_uom = this.drug2_dose_uom;
      }

      const response = await DrugService.basicDrugInfo(data);
      this.refreshPresentations_mx(response.data);

      if (response.data.drug1) {
        this.drug1_allow_maxdose = response.data.drug1.drug1_maxdose;
      }

      this.containerDescriptions = response.data.container_description_options;

      response.data.presentation_ids.reverse();
      const drugPresentationId = response.data.presentation_ids[0];

      this.drugPresentationId = drugPresentationId;

      if (this.inEditMode && this.editDrug.containerId !== "") {
        this.containerId = this.editDrug.containerId;
        this.editDrug.containerId = "";
      }

      this.checkDrugConditions();
    },
    /**
     * Get ancillaries once the container description is selected
     * Method is called once contaierId value is changed
     *
     */
    async getAncillaries() {
      if (!this.drug1_dose_uom) {
        return;
      }

      // The selected container description id
      const selectedContainerDesc = Object.values(this.containerDescriptions).find(
        (desc) => desc.containerPartCode === this.containerId
      );
      if (selectedContainerDesc.componentId) {
        this.selectedConatierDescId = selectedContainerDesc.componentId;
      } else {
        this.selectedConatierDescId = selectedContainerDesc.containerID;
      }

      const reqData = {
        reference: "getAncillaries",
        drug1Dose: this.drug1_dose,
        drug1_name: this.drug1_name,
        drug1_maxdose_uom: this.drug1_dose_uom,
        admin_route_code: this.adminRouteCode,
        containerTypeId: this.containerTypeId,
        containerPartCode: this.containerId,
        diluent_id: this.diluent_id,
        containerId: this.selectedConatierDescId,
        infusionTime: this.round_2(this.infusionTime),
        infusionTimeDuration: this.infusionTimeDuration,
        type: "PS",
      };
      this.selectedConatierDescId = selectedContainerDesc.containerID;

      if (this.displaySecondDrug && this.drug2_id !== "") {
        reqData.drug2_id = this.drug2_id;
        reqData.drug2_dose_uom = this.drug2_dose_uom;
      }

      const response = await DrugService.basicDrugInfo(reqData);
      this.ancillaries = response.data.ancillary_options;

      function compare(a, b) {
        if (a.genericName < b.genericName) {
          return -1;
        }
        if (a.genericName > b.genericName) {
          return 1;
        }
        return 0;
      }

      if (this.ancillaries) {
        const ancillariesSorted = Object.values(this.ancillaries);
        ancillariesSorted.sort(compare);
        this.ancillaries = ancillariesSorted;
      }
      response.data.presentation_ids.reverse();
      const drugPresentationId = response.data.presentation_ids[0];
      this.drugPresentationId = drugPresentationId;
      this.refreshPresentations_mx(response.data);

      if (response.data.drug1) {
        this.drug1_allow_maxdose = response.data.drug1.drug1_maxdose;
      }

      if (this.inEditMode) {
        if (
          typeof this.editDrug.ancillary1Id !== "undefined" &&
          this.editDrug.ancillary1Id !== "" &&
          this.editDrug.ancillary1Id !== false
        ) {
          this.ancillary1Id = this.editDrug.ancillary1Id;
          this.editDrug.ancillary1Id = "";
        }

        if (
          typeof this.editDrug.ancillary2Id !== "undefined" &&
          this.editDrug.ancillary2Id !== "" &&
          this.editDrug.ancillary2Id !== false
        ) {
          this.showSecondAncillary = true;
          this.ancillary2Id = this.editDrug.ancillary2Id;
          this.editDrug.ancillary2Id = "";
        }
      }

      if (selectedContainerDesc.genericName.toLowerCase() === "syringe") {
        // Check if default ancillary part code is in response
        if (
          typeof response.data.default_ancillary_part_code !== "undefined" &&
          this.ancillary1Id === ""
        ) {
          this.hasDefaultAncillary = true;
          this.defaultAncillaryValue = response.data.default_ancillary_part_code;
        }
      }
    },
    /**
     * On Ancillary value change call drugPresentation
     *
     * @return {[type]} [description]
     */
    async onAncillaryChange() {
      const selectedContainerDesc = Object.values(this.containerDescriptions).find(
        (desc) => desc.containerPartCode === this.containerId
      );
      if (!selectedContainerDesc) {
        return false;
      }

      if (selectedContainerDesc.componentId) {
        this.selectedConatierDescId = selectedContainerDesc.componentId;
      } else {
        this.selectedConatierDescId = selectedContainerDesc.containerID;
      }

      const reqData = {
        reference: "onAncillaryChange",
        drug1Dose: this.drug1_dose,
        drug1_name: this.drug1_name,
        drug1_maxdose_uom: this.drug1_maxdose_uom,
        admin_route_code: this.adminRouteCode,
        containerTypeId: this.containerTypeId,
        containerPartCode: this.containerId,
        diluent_id: this.diluent_id,
        containerId: this.selectedConatierDescId,
        infusionTime: this.round_2(this.infusionTime),
        infusionTimeDuration: this.infusionTimeDuration,
        ancillary1Id: this.ancillary1Id,
        ancillary2Id: this.ancillary2Id,
        type: this.drugOne.type,
      };

      this.selectedConatierDescId = selectedContainerDesc.containerID;

      if (this.displaySecondDrug && this.drug2_id !== "") {
        reqData.drug2_id = this.drug2_id;
        reqData.drug2_dose_uom = this.drug2_dose_uom;
      }

      const res = await DrugService.basicDrugInfo(reqData);
      this.refreshPresentations_mx(res.data);
      res.data.presentation_ids.reverse();
      const drugPresentationId = res.data.presentation_ids[0];
      this.drugPresentationId = drugPresentationId;
      return true;
    },

    /**
     * Events
     *
     */

    /**
     * Check diluent volume and diluent exact volume
     *
     * @return {[type]} [description]
     */
    checkDrugConditions() {
      if (this.containerTypes && Object.values(this.containerTypes).length > 0) {
        const selectedContainer = _.entries(this.containerTypes).find(
          (container) => container[0] === this.containerTypeId
        );
        this.selectedContainer = selectedContainer;

        if (typeof selectedContainer === "undefined") {
          throw new Error("invalid container type selected");
        }

        if (
          selectedContainer[1] === "EmptyBag" ||
          selectedContainer[1] === "Empty Bag" ||
          selectedContainer[1] === "Reservoir" ||
          selectedContainer[1] === "Syringe"
        ) {
          this.hideExactFinalVolume = false;
          this.hasInfusionTime = false;
          if (this.diluent_id !== "" && this.diluent_id !== null) {
            this.isExactVolumeOptional = false;
            this.diluentExactFinalVolume = true;
            this.disableDiluentExactFinalVolume = true;
            this.hasDefaultDiluentVolume = false;
            if (this.inEditMode) {
              this.diluentVolume = this.round_2(this.editDrug.diluentVolume); // round to 2 dp;
            }
          } else if (this.isFavourite) {
            this.isExactVolumeOptional = true;
            this.diluentExactFinalVolume = false;
            this.disableDiluentExactFinalVolume = true;
            this.hasDefaultDiluentVolume = false;
            this.diluentVolume = "";
          } else {
            this.isExactVolumeOptional = true;
            this.diluentExactFinalVolume = false;
            this.disableDiluentExactFinalVolume = true;
            this.hasDefaultDiluentVolume = false;
          }
        } else if (selectedContainer[1] === "Fluid Bag" || selectedContainer[1] === "FluidBag") {
          this.hideExactFinalVolume = false;
          this.isExactVolumeOptional = true;
          this.diluentExactFinalVolume = false;
          this.disableDiluentExactFinalVolume = false;
          this.hasDefaultDiluentVolume = true;
          this.hasInfusionTime = false;
          if (this.inEditMode) {
            this.diluentExactFinalVolume = this.editDrug.diluentExactFinalVolume;
            this.diluentVolume = this.round_2(this.editDrug.diluentVolume); // round to 2 dp;
          }
        } else if (selectedContainer[1] === "Intermate" || selectedContainer[1] === "Infusor") {
          this.hideExactFinalVolume = true;
          this.isExactVolumeOptional = true;
          this.diluentExactFinalVolume = false;
          this.disableDiluentExactFinalVolume = false;
          this.hasDefaultDiluentVolume = true;
          this.hasInfusionTime = true;
          if (this.inEditMode) {
            this.diluentExactFinalVolume = this.editDrug.diluentExactFinalVolume;
            this.diluentVolume = this.round_2(this.editDrug.diluentVolume); // round to 2 dp;
          }
        }
      }
    },
    /**
     * Check for default ancillary values
     *
     */
    setDefaultAncillary() {
      const ancillaries = _.values(this.ancillaries);

      if (ancillaries.length > 0) {
        const defaultAncillary = _.find(
          ancillaries,
          (ancillary) => ancillary.componentPartCode === this.defaultAncillaryValue
        );
        if (typeof defaultAncillary !== "undefined") {
          this.ancillary1Id = defaultAncillary.componentID;
        }
      }
    },
    /**
     * Delete drug one info and empty drug one name, dose and uom
     * Removing drug one removes drug two as well
     */
    deleteDrugOne() {
      this.inEditMode = false;
      this.drugOne = {};
      this.drug1_name = "";
      this.drug1_dose = "";
      this.drug1_maxdose = "";
      this.adminRouteCode = "";
      this.containerTypeId = "";
      this.diluent_id = "";
      this.infusionTime = "";
      this.infusionTimeDuration = "hours";
      this.containerId = "";
      this.diluentVolume = "";
      this.ancillary1Id = "";
      this.ancillary2Id = "";
      this.treatmentDate = "";
      this.drug1_stability_data = false;
      this.deliveryDateArray = [];
      this.adminRoutes = [];
      this.deleteSecondDrug();
      this.clearFavourite();
      this.getOrderInfo();
    },
    /**
     * Delete drug two related info
     *
     */
    deleteSecondDrug() {
      this.inEditMode = false;
      this.drug2_dose = "";
      this.drug2_maxdose = "";
      this.drug2_id = "";
      this.displaySecondDrug = false;
    },
    /**
     * Add second drug to ui
     * Displays second drup option if drug one presentation have second drug in it
     */
    showSecondDrug() {
      this.displaySecondDrug = true;
    },
    /**
     * Exact volume change event
     * Event trigger is checkout input element
     * Based on contaier description selection and whether the default value is allowed to
     * set or not the default volume is set
     */
    onExactVolumeChange() {
      this.setDefaultDiluentVolume();
    },
    /**
     * Display second ancillary input field
     *
     */
    displaySecondAncillary() {
      this.showSecondAncillary = true;
    },

    async addOrderTPNProduct() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const reqData = {
          orderRef: this.$route.params.orderId,
          patientId: 0,
          quantity: this.quantity,
          tpn_code: this.drug1_product_code,
          tpn_product: this.drug1_name,
          type: "TPN",
          deliveryDateArray: this.deliveryDateArray,
          max_batch_size: this.max_batch_size,
          qtyMultiple: parseInt(this.qtyMultiple, 0),
        };
        reqData.isFavourite = this.isFavourite;
        reqData.editRequired = false;

        this.waiting_on();

        OrderDrugService.addDrugForPatient(reqData).then(() => {
          this.resetAddDrugForm();
          this.addDrugComplete = true;
          this.$emit("refreshOrderInfo");
          this.getOrderInfo();
          this.waiting_off();
          this.checkUpdateDraft();
        });
      }
    },
    async updateOrderTPNProduct() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const reqData = {
          orderRef: this.$route.params.orderId,
          oldDrugPresentationId: 0,
          drugPresentationId: 0,
          patientId: 0,
          quantity: this.quantity,
          tpn_code: this.drug1_product_code,
          tpn_product: this.drug1_name,
          type: "TPN",
          deliveryDateArray: this.deliveryDateArray,
          orderLineItemId: this.editDrug.orderLineItemId,
          max_batch_size: this.max_batch_size,
          qtyMultiple: parseInt(this.qtyMultiple, 0),
        };
        reqData.isFavourite = this.isFavourite;
        reqData.editRequired = false;

        this.waiting_on();
        OrderDrugService.updateDrug(reqData).then(() => {
          this.waiting_off();
          this.editDrugModal = true;
        });
      }
    },
    /**
     * Submit form methods
     * Invoke validation, return on validation error
     *
     */
    async submitDrug() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        let reqData = {};

        if (this.addingFpDrug || (await this.additionalValidation())) {
          if (this.addingFpDrug) {
            reqData = {
              orderRef: this.$route.params.orderId,
              patientId: typeof this.patient.patientId === "undefined" ? 0 : this.patient.patientId,
              quantity: this.quantity,
              drugPresentationId: this.drugPresentationId,
              fp_code: this.drug1_product_code,
              treatmentDate: this.treatmentDate,
              deliveryDateArray: this.deliveryDateArray,
              type: "FP",
            };
          } else {
            reqData = {
              orderRef: this.$route.params.orderId,
              patientId: typeof this.patient.patientId === "undefined" ? 0 : this.patient.patientId,
              quantity: this.quantity,
              drugPresentationId: this.drugPresentationId,
              drug1Dose: this.drug1_dose,
              drug1DoseSplit: this.drug1_doses_split,
              drug2Dose: this.drug2_dose,
              containerTypeId: this.containerTypeId,
              diluentVolume: this.diluentVolume,
              diluentExactFinalVolume: this.diluentExactFinalVolume,
              treatmentDate: this.treatmentDate,
              deliveryDateArray: this.deliveryDateArray,
              onHold: this.onHold,
              adminRouteCode: this.adminRouteCode,
              ancillary1Id: this.ancillary1Id,
              ancillary2Id: this.ancillary2Id,
              infusionTime: this.round_2(this.infusionTime),
              infusionTimeDuration: this.infusionTimeDuration,
              containerPartCode: this.containerId,
              diluent_id: this.diluent_id,
              containerId: this.selectedConatierDescId,
              overrideStability: this.overrideStability,
              overrideDosage: this.maxDosageExceededAccepted,
              type: "PS",
            };
          }

          reqData.drugName = this.generateDrugName();
          reqData.isFavourite = this.isFavourite;
          this.waiting_on();

          OrderDrugService.addDrugForPatient(reqData).then(() => {
            this.resetAddDrugForm();
            this.addDrugComplete = true;
            this.$emit("refreshOrderInfo");
            this.getOrderInfo();
            this.waiting_off();
            this.checkUpdateDraft();
          });
        }
      } else {
        setTimeout(() => {
            if (document.querySelector(".bax-form-error")) {
            window.scroll({
              top:
                document.querySelector(".bax-form-error").getBoundingClientRect().top +
                window.scrollY -
                50,
              left: 0,
              behavior: "smooth",
            });
          }
        }, 100);
      }
    },
    // new
    setDefaultDiluentVolume() {
      if (!this.containerId || this.containerId === "") {
        this.diluentVolume = "";
        this.maxDiluentVolume = "";
        this.miDiluentVolume = "";
        return;
      }

      if (this.diluent_id) {
        const selectedContainerDesc = _.find(
          this.containerDescriptions,
          (option) => option.containerPartCode === this.containerId
        );
        if (typeof selectedContainerDesc === "undefined") {
          throw new Error("invalid container description selected");
        }

        this.maxDiluentVolume = this.round_2(selectedContainerDesc.maximumVolume);
        this.minDiluentVolume = selectedContainerDesc.minimumVolume;

        if (this.diluentExactFinalVolume === false && this.hasDefaultDiluentVolume === true) {
          this.diluentVolume = this.round_2(selectedContainerDesc.sizeInDefaultUOM); // round to 2 dp;
        } else {
          // this.diluentVolume = '';
        }
        if (this.inEditMode) {
          if (this.diluentExactFinalVolume === true && this.editDrug.diluentVolume !== "") {
            this.diluentVolume = this.round_2(this.editDrug.diluentVolume); // round to 2 dp;
            // this.diluentExactFinalVolume = this.editDrug.diluentExactFinalVolume;
            this.editDrug.diluentVolume = "";
            this.editDrug.diluentExactFinalVolume = "";
          } else {
            this.diluentVolume = this.round_2(selectedContainerDesc.sizeInDefaultUOM); // round to 2 dp;
          }
        }
      }
    },
    getOrderInfo() {
      OrderService.orderInfo(this.$route.params.orderId, false, true).then((data) => {
        this.draftSaved = data.draftSaved
        this.drugCount = data.drugCount;

        if (!this.inEditMode) {
          this.deliveryDateArray = data.deliveryDateArray;
        }
        this.deliveryDate_recalc();
      });
    },
    addOrderDrug() {
      this.submitDrug();
    },
    async updateDrug() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {};

        if (this.type === "TPN" || this.addingFpDrug || (await this.additionalValidation())) {
          if (this.type === "TPN") {
            data = {
              orderRef: this.$route.params.orderId,
              patientId: 0,
              quantity: this.quantity,
              fp_code: this.drug1_product_code,
              type: "FP",
              drugPresentationId: "",
              oldDrugPresentationId: this.oldDrugPresentationId,
              drug1Dose: this.drug1_dose,
              drug1DoseSplit: this.drug1_doses_split,
              drug1DoseUom: this.drug1_maxdose_uom,
              containerTypeId: this.containerTypeId,
              drug2Dose: this.drug2_dose,
              diluentVolume: this.diluentVolume,
              diluentExactFinalVolume: this.diluentExactFinalVolume,
              treatmentDate: this.treatmentDate,
              deliveryDateArray: this.deliveryDateArray,
              infusionTime: this.round_2(this.infusionTime),
              infusionTimeDuration: this.infusionTimeDuration,
              ancillary1Id: this.ancillary1Id,
              ancillary2Id: this.ancillary2Id,
              onHold: this.onHold,
              adminRouteCode: this.adminRouteCode,
              containerPartCode: this.containerId,
              diluent_id: this.diluent_id,
              containerId: this.selectedConatierDescId,
              orderLineItemId: this.editDrug.orderLineItemId,
            };
          } else if (this.addingFpDrug) {
            data = {
              orderRef: this.$route.params.orderId,
              patientId: typeof this.patient.patientId === "undefined" ? 0 : this.patient.patientId,
              quantity: this.quantity,
              fp_code: this.drug1_product_code,
              type: "FP",
              drugPresentationId: "",
              oldDrugPresentationId: this.oldDrugPresentationId,
              drug1Dose: this.drug1_dose,
              drug1DoseSplit: this.drug1_doses_split,
              drug1DoseUom: this.drug1_maxdose_uom,
              containerTypeId: this.containerTypeId,
              drug2Dose: this.drug2_dose,
              diluentVolume: this.diluentVolume,
              diluentExactFinalVolume: this.diluentExactFinalVolume,
              treatmentDate: this.treatmentDate,
              deliveryDateArray: this.deliveryDateArray,
              infusionTime: this.round_2(this.infusionTime),
              infusionTimeDuration: this.infusionTimeDuration,
              ancillary1Id: this.ancillary1Id,
              ancillary2Id: this.ancillary2Id,
              onHold: this.onHold,
              adminRouteCode: this.adminRouteCode,
              containerPartCode: this.containerId,
              diluent_id: this.diluent_id,
              containerId: this.selectedConatierDescId,
              orderLineItemId: this.editDrug.orderLineItemId,
            };
          } else {
            data = {
              orderRef: this.$route.params.orderId,
              patientId: typeof this.patient.patientId === "undefined" ? 0 : this.patient.patientId,
              quantity: this.quantity,
              oldDrugPresentationId: this.oldDrugPresentationId,
              drugPresentationId: this.drugPresentationId,
              drug1Dose: this.drug1_dose,
              drug1DoseSplit: this.drug1_doses_split,
              drug1DoseUom: this.drug1_maxdose_uom,
              drug2Dose: this.drug2_dose,
              diluentVolume: this.diluentVolume,
              diluentExactFinalVolume: this.diluentExactFinalVolume,
              treatmentDate: this.treatmentDate,
              deliveryDateArray: this.deliveryDateArray,
              infusionTime: this.round_2(this.infusionTime),
              infusionTimeDuration: this.infusionTimeDuration,
              ancillary1Id: this.ancillary1Id,
              ancillary2Id: this.ancillary2Id,
              onHold: this.onHold,
              containerTypeId: this.containerTypeId,
              adminRouteCode: this.adminRouteCode,
              containerPartCode: this.containerId,
              diluent_id: this.diluent_id,
              containerId: this.selectedConatierDescId,
              orderLineItemId: this.editDrug.orderLineItemId,
              overrideStability: this.overrideStability,
              overrideDosage: this.maxDosageExceededAccepted,
              type: "PS",
            };
          }
          this.waiting_on();
          data.drugName = this.generateDrugName();
          data.isFavourite = this.isFavourite;
          data.editRequired = false;
          OrderDrugService.updateDrug(data).then(() => {
            this.waiting_off();
            this.editDrugModal = true;
          });
        }
      }
    },
    checkMaxiumumDosage() {
      this.drugsExceedingMaxDosage = [];
      if (parseFloat(this.drug1_dose) > parseFloat(this.drug1_maxdose)) {
        this.drugsExceedingMaxDosage.push({
          drug: this.drugOne.label,
          dosage: this.drug1_maxdose + " " + this.drug1_dose_uom,
        });
      }
      if (this.drug2_dose) {
        if (parseFloat(this.drug2_dose) > parseFloat(this.drug2_maxdose)) {
          this.drugsExceedingMaxDosage.push({
            drug: this.drug2Options[this.drug2_id],
            dosage: this.drug2_maxdose + " " + this.drug2_dose_uom,
          });
        }
      }
      if (this.drugsExceedingMaxDosage.length > 0) {
        if (!this.maxDosageExceededAccepted) {
          this.maxDosageModalOpen = true;
          return false;
        }
      }
      return true;
    },
    async checkSubmissionErrors() {
      let validSubmission = true;
      let orderValidationRef = this.$route.params.orderId + "validationtest";

      let orderValidationData = {
        comment: "",
        deliveryDate: "01/01/2031",
        deliveryTime: "",
        orderRef: orderValidationRef,
      };
      this.waiting_on();
      await OrderService.createOrder(orderValidationData).then(async (res) => {
        orderValidationRef = res.data.orderRef;

        // HERE
        orderValidationData = {
          orderRef: orderValidationRef,
          patientId: 0,
          quantity: 1,
          drugPresentationId: this.drugPresentationId,
          drug1Dose: this.drug1_dose,
          drug1DoseSplit: this.drug1_doses_split,
          drug1DoseUom: this.drug1_maxdose_uom,
          drug2Dose: this.drug2_dose,
          containerTypeId: this.containerTypeId,
          diluentVolume: this.diluentVolume,
          drugName: this.generateDrugName(),
          diluentExactFinalVolume: this.diluentExactFinalVolume,
          treatmentDate: this.treatmentDate,
          deliveryDateArray: this.deliveryDateArray,
          onHold: this.onHold,
          adminRouteCode: this.adminRouteCode,
          ancillary1Id: this.ancillary1Id,
          ancillary2Id: this.ancillary2Id,
          infusionTime: this.round_2(this.infusionTime),
          infusionTimeDuration: this.infusionTimeDuration,
          containerPartCode: this.containerId,
          diluent_id: this.diluent_id,
          containerId: this.selectedConatierDescId,
          type: "PS",
        };

        await OrderDrugService.addDrugForPatient(orderValidationData).then(async () => {
          await OrderService.validateOrder({
            orderRef: orderValidationRef,
            validateOnly: true,
          }).then((validationRes) => {
            if (validationRes.data.message === "error") {
              let errorMessage = "";
              let stabilityError = false;
              validationRes.data.payload.forEach((value, i) => {
                switch (value) {
                  case "VLD-MIS-STABILITY":
                  case "MissingStability":
                  case "MissingStability2":
                    stabilityError = true;
                    break;
                  case "VLD-TEX-DRUG1DOSE":
                  case "VLD-TEX-DRUG2DOSE":
                  case "VLD-UNX-ADMINISTRATIONDATE":
                  case "RemovalVolumeRange":
                  case "RemovalVolume":
                    // we dont care about dosage errors
                    break;
                  case "VLD-GMX-TOTALVOLUME":
                  case "VLD-INV-SYRINGEVOLUME":
                  case "VLD-INV-CALCULATEDDILUENTVOLUME":
                    errorMessage += "Drug volume exceeds container size.";
                    if (this.maxDiluentVolume && (this.maxDiluentVolume < 5000)) {
                      errorMessage += " Max fill volume is " + this.round_2(this.maxDiluentVolume) + "mL";
                    }
                    if ((!this.exceedContainerModalOpen) && (this.containerTypes[this.containerTypeId] === 'Syringe') && (!this.diluent_id)) {
                      this.checkDosageContainer();
                      this.exceedContainerModalOpen = true;
                      errorMessage = '';
                      validSubmission = false;
                    }
                    break;
                  case "INVALID_LINE":
                    if (validationRes.data.payloadDetail[i]) {
                      errorMessage += validationRes.data.payloadDetail[i];
                    } else {
                      errorMessage += "Unknown error ";
                    }
                    break;
                  default:
                    errorMessage += "Unknown error code : " + value + ". \n\n";
                    errorMessage += "<BR /><BR />" + validationRes.data.payloadDetail[i] + "<BR /><BR />";
                    break;
                }
              });
              if (errorMessage.length) {
                this.genericErrorText = errorMessage;
                validSubmission = false;
              } else if (stabilityError) {
                if (!this.overrideStability) {
                  this.showStabilityError = true;
                  validSubmission = false;
                }
              }
            }
            this.waiting_off();
          });
          // .catch((err) => {
          //     if (err.response.status === 400) {
          //     }
          // });
        });
      });

      return validSubmission;
    },
    async additionalValidation() {
      return this.checkMaxiumumDosage() && this.checkSubmissionErrors();
    },
    async stabilitySubmit() {
      this.overrideStability = true;
      this.showStabilityError = false;
      if (this.edit) {
        this.updateDrug();
      } else {
        this.addOrderDrug();
      }
    },
    checkDosageContainer() {
      this.drugExceedingContainerSize = {
        dosage: this.drug1_dose,
        name: this.drug1_name,
        unit: this.drug1_dose_uom,
        dates: this.deliveryDateArray,
        diluentVolume: this.diluentVolume
      };
    },
    maxDosageApproved() {
      this.maxDosageExceededAccepted = true;
      this.maxDosageModalOpen = false;
      if (this.edit) {
        this.updateDrug();
      } else {
        this.addOrderDrug();
      }
    },
    closeAddDrugModal() {
      this.addDrugComplete = false;
      this.$v.$reset();
      scrollPageToTop();
    },
    goBackAfterEdit() {
      // this.$router.go(-1);
      this.goToReview();
    },
    goToPatientSelect() {
      this.$router.push({
        path: `/order/${this.$route.params.orderId}/select-patient`,
      });
    },
    saveDraftOrder() {
      this.draftModal = true;
    },
    onGoToReview() {
      if (this.drug1_name !== "") {
        this.formInProgress = true;
      } else {
        this.goToReview();
      }
    },
    goToReview() {
      // if (this.$v.$dirty === true && this.$v.$invalid === true) {
      //     return;
      // }

      const { patient } = this.$route.params;
      const reviewPage = this.type === "TPN" ? "reviewCompleteTPN" : "reviewComplete";
      if (patient !== "" && typeof patient !== "undefined") {
        this.$router.push({
          name: reviewPage,
          params: {
            orderId: this.$route.params.orderId,
          },
          query: {
            patient,
          },
        });
      } else {
        this.$router.push({
          name: reviewPage,
          params: {
            orderId: this.$route.params.orderId,
          },
        });
      }
    },
    resetAddDrugForm() {
      this.addingFpDrug = false;
      this.drugOne = {};
      this.drug1_product_code = "";
      this.drug1_stability = "";
      this.drugPresentationId = "";
      this.quantity = "";
      this.drug1_name = "";
      this.drug1_maxdose = "";
      this.drug1_maxdose_uom = "";
      this.drug1_stability_data = false;
      this.adminRouteCode = "";
      this.containerTypeId = "";
      this.diluent_id = "";
      this.infusionTime = "";
      this.infusionTimeDuration = "hours";
      this.containerId = "";
      this.diluentVolume = "";
      this.diluentExactFinalVolume = false;
      this.ancillary1Id = "";
      this.ancillary2Id = "";
      this.treatmentDate = "";
      this.deliveryDateArray = [];
      this.onHold = false;
      this.$v.$reset();
      this.displaySecondDrug = false;
      this.hideExactFinalVolume = false;
      this.showStabilityError = false;
      this.maxDosageExceededAccepted = false;
      this.overrideStability = false;
      this.isFavourite = false;
      this.minQuantity = false;
      this.drug_warning = '';
    },
    checkUpdateDraft() {
      // if a draft exists then update it
      if (this.$route.params.orderId) {
        OrderService.submitDraftOrder({
          orderRef: this.$route.params.orderId,
          type: this.type,
        })
      }
    },
    decimals_0($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    round_2($num) {
      return this.rounddec_2($num);
    },
    deliveryDate_add() {
      this.deliveryDateArray.push([false, false, 0]);
      this.deliveryDate_recalc();
    },
    deliveryDate_remove(index) {
      this.deliveryDateArray.splice(index, 1);
    },
    deliveryDate_recalc() {
      for (let i = 0; i < this.deliveryDateArray?.length; i += 1) {
        this.deliveryDateArray[i][3] = i + 1;
        if (this.deliveryDateArray[i][1] === '') {
          this.deliveryDateArray[i][1] = false;
        }
        if (this.deliveryDateArray[i][0] !== false) {
          this.deliveryDateArray[i][0] = moment(this.deliveryDateArray[i][0], 'DD/MM/YYYY').format("DD/MM/YYYY");
        }
        if (this.deliveryDateArray[i][1] !== false) {
          this.deliveryDateArray[i][1] = moment(this.deliveryDateArray[i][1], 'DD/MM/YYYY').format("DD/MM/YYYY");
        }
      }
    },
    treatmentDateError(deliveryDate, treatmentDate) {
      if (!treatmentDate && (treatmentDate === '')) {
        return false; // no error
      }
      const formatteddeliveryDate = moment(deliveryDate, ["DD/MM/YYYY", "D/M/YYYY", "D/MM/YYYY"]);
      const formattedtreatmentDate = moment(treatmentDate, ["DD/MM/YYYY", "D/M/YYYY", "D/MM/YYYY"]);

      if (formattedtreatmentDate.diff(formatteddeliveryDate, "days") < 0) {
        return "Please provide a valid treatment date";
      }
      return false;
    },
    deliveryDateError(date, required) {
      if (!required && !date) {
        return false; // no error
      }
      if (!required && (date === '')) {
        return false; // no error
      }

      if (!date) {
        return "Please provide a date";
      }
      if (moment(date, ["DD/MM/YYYY", "D/M/YYYY", "D/MM/YYYY"], true).isValid() === false) {
        return "Please provide a valid date";
      }

      const today = moment().format("DD/MM/YYYY");

      const now = moment(today, "DD/MM/YYYY");
      const checkdate = moment(date, ["DD/MM/YYYY", "D/M/YYYY", "D/MM/YYYY"]);

      if (checkdate.diff(now, "days") < 0) {
        return "Please provide a future date";
      }
      return false;
    },
    deliveryQtyError(qty, required) {
      if (!required && !qty) {
        return false; // no error
      }

      if (!qty) {
        return "Please provide a quantity";
      }

      if (qty <= 0) {
        return "Please provide a quantity greater than zero";
      }
      if (parseInt(this.minQuantity, 10) && parseInt(qty, 10) < parseInt(this.minQuantity, 10)) {
        return "Quantity ordered is less than the minimum of " + this.minQuantity;
      }
      if (this.qtyMultiple && qty % this.qtyMultiple !== 0) {
        return "Order quantity must be in multiples of " + this.qtyMultiple;
      }
      return false;
    },
    onModalViewStabilityOpen() {
        this.modalViewStability = true;
    },
    onModalViewStabilityClose() {
        this.modalViewStability = false;
    },
  },
};
</script>

<style scoped lang="scss">
form {
  p {
    color: red;
  }
}

.bax-input-control {
  height: 60px;
}
</style>
